import {useMemo} from 'react';

import {TForecastCommentsCore} from '../../../model/types';

/**
 * Хук для проверки заполненности обязательных полей
 * @param forecastComments - Данные c бэкенда
 *
 * @returns {boolean} Флаг, указывающий что все обязательные поля заполнены
 */
export const useRequiredFieldsFilled = (forecastComments: TForecastCommentsCore): boolean =>
    useMemo(
        () => forecastComments.factors.every((factor) => factor?.forecastValueOrg && factor?.forecastCommentOrg),
        [forecastComments.factors]
    );
